import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rc0009',
    ecrans: ['00-2']
});
